<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/warehouse/page" getKey="rows"
        :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('cangkubianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cangkumingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('cangkuleixing')">
            <el-select v-model="yt.conditions.type">
              <el-option :label="$t('chengpincang')" :value="'1'"></el-option>
              <el-option :label="$t('cailiaocang')" :value="'2'"></el-option>
              <el-option :label="$t('xianbiancang')" :value="'3'"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({orderBy:'code asc'})">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 自定义某个字段 -->
      <template #cangkuleixing="scope">
        <!-- 仓库类型 -->
        <template v-if="scope.row.type == '1'">
          {{ $t('chengpincang') }}
        </template>
        <template v-if="scope.row.type == '2'">
          {{ $t('cailiaocang') }}
        </template>
        <template v-if="scope.row.type == '3'">
          {{ $t('xianbiancang') }}
        </template>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
// import reservoir_area from '@@/pages/web/base/warehouse_model/reservoir_area'
// import importExcel from '@@/pages/web/base/warehouse_model/import_excel'

export default {
  name: 'web_wms_mrp_details_shortage_calculation',
  // components: {
  //   importExcel,
  //   reservoir_area
  // },
  data() {
    return {
      ids:null,
      columns: [{
        label: 'xuanze',
        type: 'selection',
      },{
        label: 'cangkubianma',
        prop: 'code',
        width: 130
      }, {
        label: 'cangkumingcheng',
        prop: 'name'
      },
        {
          label: 'cangkuleixing',
          prop: 'type',
          type: 'slot'
        },
        {
          label: 'dizhi',
          prop: 'address'
        },
        ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = "/web/basic/warehouse/getWarehouseByIds"
      this.yt.SELECT_RESULT_KEY = "data"
      this.yt.SELECT_ID = "id"
      this.yt.SELECT_TITLE = "name"
      this.yt.conditions = {
        orderBy: 'code asc',
      }
      this.utils.event_hub.$on('WAREHOUSE_LIST_REFRESH', () => {
        this.yt.get(1);
      })
      this.yt.get(1)
    }, 300)
  },
  methods: {
    selectionChange(items) {
      this.ids = items.map(item => {
        return item.id
      })
    },
  }
};
</script>
